import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { StyleSheet, View } from 'react-native';

import { Impact } from '@/api/models/impactModels';
import Text from '@/components/Text';
import { formatCurrency } from '@/utils/currencyFormat';

interface ImpactMarkerWebProps {
  data: Impact;
  showDonation?: () => void;
}

const ImpactMarkerWeb = ({ data, showDonation }: ImpactMarkerWebProps) => {
  const latAbs = Math.abs(data.latitude);
  const longAbs = Math.abs(data.longitude);

  if (latAbs < 0 || latAbs > 90) {
    console.error('Latitude needs to be between -90 and 90 degress.');
    return null;
  }

  if (longAbs < 0 || longAbs > 180) {
    console.error('Longitude needs to be between -180 and 180 degress.');
    return null;
  }

  return (
    <AdvancedMarker
      position={{ lat: data.latitude, lng: data.longitude }}
      onClick={() => {
        if (showDonation) showDonation();
      }}>
      <View style={styles.donationPill}>
        <Text style={styles.donationPillText}>{formatCurrency(data.amount)}</Text>
      </View>
    </AdvancedMarker>
  );
};

const styles = StyleSheet.create({
  donationPill: {
    backgroundColor: 'white',
    paddingHorizontal: 7,
    paddingVertical: 5,
    borderRadius: 20,
    borderColor: 'black',
    borderWidth: 1,
    alignSelf: 'center'
  },
  donationPillText: {
    color: 'black',
    fontSize: 14
  }
});

export default ImpactMarkerWeb;
